module.exports = __webpack_public_path__ + "static/media/bg-right-img-2.c83dc045.jpg";